import { ElementType } from 'react'

import { Text, TextProps } from '@lounge-fe/ui-kit/src/components/Text'

const defaultElement = 'h5'

const Title = <E extends ElementType = typeof defaultElement>(
  props: TextProps<E>,
) =>
  props.children ? (
    <Text
      variant="body-lg"
      as={defaultElement}
      className="text-[#727575] font-regular"
      {...props}
    />
  ) : null

export default Title
